// const url = 'http://localhost:3002';
// const url = 'http://3.87.87.6:8000';
const url = 'https://kizc0yz1vi.execute-api.us-west-2.amazonaws.com/prod';
const socketUrl = 'http://localhost:3004';
const googleApiKey = 'AIzaSyCXu9degEWI9i7CnlTiqGk567YRw3AG2z0'
const validCurrency = ['USD']
const app_version = 'V1.0 Beta'
const llmUrl = 'https://t93gsz4ju9.execute-api.us-east-1.amazonaws.com/dev/api';

export { url, googleApiKey, socketUrl, validCurrency, app_version, llmUrl };
